import { getColumnDefByResourceType } from "@/components/pages/common/resources-ag-grid/components/column-defs/getColumnDefByResourceType";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { stringifyResourceColumnDef } from "@/components/pages/common/resource-details/components/content/general-content/components/details/resource-details-general-content-details-generator/stringifyResourceColumnDef";
import { colDefsWithCustomComponents } from "@/components/pages/common/resource-details/components/content/general-content/components/details/ResourceDetailsGeneralContentDetails";
import { isCustomValueComponentIdentifierKeys } from "@/store/resource-details/utils/helpers/isCustomValueComponentIdentifierKeys";

export const resourceDetailsGeneralContentDetailsFromResourceGenerator = (
  resource: AllTypeResourceItem | null,
  disabledColDefIds: string[],
  ignoreCellRenderer?: boolean,
  ignoreCustomComponents?: boolean,
) => {
  if (!resource) {
    return [];
  }

  const resourceType = resource.resource_type;

  const colDefs =
    getColumnDefByResourceType(resourceType)?.filter((col) => {
      const id = col.field ?? col.colId ?? "";

      return !disabledColDefIds.includes(id);
    }) ?? [];

  const details = colDefs
    .map((col) => {
      const CustomComponent =
        (isCustomValueComponentIdentifierKeys(col.field) &&
          colDefsWithCustomComponents[col.field]) ||
        (isCustomValueComponentIdentifierKeys(col.colId) &&
          colDefsWithCustomComponents[col.colId]);

      if (CustomComponent && !ignoreCustomComponents) {
        return {
          title: col.headerName ?? "",
          value: <CustomComponent {...resource} />,
        };
      }

      const value = stringifyResourceColumnDef(
        col,
        resource,
        ignoreCellRenderer,
      );

      const title = col.headerName;

      if (!title) {
        return null;
      }

      return { title, value: value ?? "-" };
    })
    .filter((detail) => !!detail);

  return details;
};
